import sgccApi from "@/api/sgccApi"

export const obtainAllCohorts = async ( { commit } ) => {
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.get(`/api/cohorte`)
        if (data.ok) {
            commit('setCohorts', data.cohortes)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error }
    }
}

export const editCohorts = async ( _, { form } ) => {
    const cohortsForm = {
        nombre: form.nombre,
        fechaInicio: typeof form.fechaInicio == "object" ? form.fechaInicio.getFullYear()+"-"+(form.fechaInicio.getMonth()+1)+"-"+form.fechaInicio.getDate() : form.fechaInicio,
        fechaFin: typeof form.fechaFin == "object" ? form.fechaFin.getFullYear()+"-"+(form.fechaFin.getMonth()+1)+"-"+form.fechaFin.getDate() : form.fechaFin,
    }
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.put(`/api/cohorte/${form.id}`, cohortsForm)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error?.response?.data?.message }
    }
}

export const createCohorts = async ( _, { form } ) => {
    const cohortsForm = {
        nombre: form.nombre,
        fechaInicio: form.fechaInicio.getFullYear()+"-"+(form.fechaInicio.getMonth()+1)+"-"+form.fechaInicio.getDate(),
        fechaFin: form.fechaFin.getFullYear()+"-"+(form.fechaFin.getMonth()+1)+"-"+form.fechaFin.getDate()
    }
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.post(`/api/cohorte`, cohortsForm)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error?.response?.data?.message }
    }
}

export const deleteCohorts = async ( _, id ) => {
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.delete(`/api/cohorte/${id}`)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}